module.exports = __webpack_public_path__ + "static/img/youxiaSkill.eda41c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/youxiaSkill.png
// module id = 2wVg
// module chunks = 0